import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO } from "@/lib/api";

export default function Login() {
  const { login, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate(redirect);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink px-4" data-testid="login-page">
      <div className="w-full max-w-md bg-white p-10">
        <Link to="/" className="flex justify-center mb-8"><img src={LOGO} alt="Rock Hard Tennis" className="h-20 w-20 object-contain" /></Link>
        <h1 className="font-display text-3xl uppercase text-center mb-2">Welcome Back</h1>
        <p className="text-center text-sm text-gray-500 mb-8">Log in to your account</p>
        {error && <p className="bg-sale/10 text-sale text-sm p-3 mb-4 text-center" data-testid="login-error">{error}</p>}
        <form onSubmit={submit} className="flex flex-col gap-5">
          <div className="flex flex-col gap-1">
            <label className="text-xs font-bold uppercase tracking-widest text-gray-500">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
              className="border-b border-gray-300 py-3 text-sm focus:outline-none focus:border-ink transition-colors" />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-xs font-bold uppercase tracking-widest text-gray-500">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
              className="border-b border-gray-300 py-3 text-sm focus:outline-none focus:border-ink transition-colors" />
          </div>
          <button type="submit" disabled={loading} className="mt-4 bg-ink text-cream py-4 font-bold uppercase tracking-widest hover:bg-ink/85 transition-colors disabled:opacity-60" data-testid="login-submit">
            {loading ? "Logging in..." : "Log In"}
          </button>
        </form>
        <p className="text-center text-sm mt-6 text-gray-500">
          No account? <Link to="/signup" className="font-bold text-ink hover:text-sale" data-testid="link-signup">Sign Up</Link>
        </p>
      </div>
    </div>
  );
}
